/* eslint react/prop-types: 0 */

import React from 'react';

const FooterInformationItem = ({ item, isNotLastItem }) => (item.type === 'link' ? (
  <>
    <a href={item.link}>{item.name}</a>
    {isNotLastItem && <div className="d-none d-md-inline">{' \u2022 '}</div>}
    <br className="d-xs-inline d-md-none" />
  </>
) : (
  <>
    <span>{item.name}</span>
    {isNotLastItem && <div className="d-none d-md-inline">{' \u2022 '}</div>}
    <br className="d-xs-inline d-md-none" />
  </>
));

export default FooterInformationItem;
